import React, { createContext, useContext } from 'react';
const UIGameTranslationContext = /*#__PURE__*/ createContext(undefined);
export const UIGameTranslationProvider = ({ children, translationKeyContext })=>/*#__PURE__*/ React.createElement(UIGameTranslationContext.Provider, {
        value: {
            translationKeyContext: translationKeyContext
        }
    }, children);
export const useUIGameTranslationContext = ()=>{
    const context = useContext(UIGameTranslationContext);
    if (!context) throw new Error('UIGameTranslationContext not found');
    return context;
};
